export default __webpack_public_path__ + "static/media/loader.72a1d675.gif";